import type { RouteObject } from 'react-router';
import { recordTabRoutes } from '../../../../shared/components/record-tab-routes';
import { WorkOrderDetailPage } from './pages/WorkOrderDetailPage';
import { WORK_ORDER_TABS } from './work-orders.paths';

/** `/maintenance/work-orders/:id/<tab>`; the bare path redirects to the first tab. The list is the Work orders tab of Maintenance. */
export const WORK_ORDER_ROUTES: RouteObject[] = recordTabRoutes('maintenance/work-orders/:id', WORK_ORDER_TABS, (tab) => <WorkOrderDetailPage tab={tab} />);
